import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets.app/images/sign-up-apple-white.svg'


const _hoisted_1 = { class: "button__text d-none d-md-inline" }
const _hoisted_2 = { class: "button__text d-md-none" }

import { ref } from 'vue'
import { AppleNativeAuthView } from '@/models/auth/apple.native'
import type { SocialAuthView } from '@/models/auth/social'
import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppleSignInButton',
  props: {
    view: {},
    title: {}
  },
  setup(__props: any) {

const props = __props

const isLoading = ref(false)

async function login(): Promise<void> {
  if (isLoading.value) {
    return
  }
  isLoading.value = true
  try {
    if (props.view instanceof AppleNativeAuthView) {
      await props.view.start()
    }
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass([__props.view.isEnabled && !isLoading.value ? '' : 'disabled', "button button--black appleSignIn shortform-sign-up__button"]),
    onClick: login
  }, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(ButtonSpinner, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _cache[0] || (_cache[0] = _createElementVNode("img", {
            class: "button__img",
            src: _imports_0,
            alt: ""
          }, null, -1)),
          _createElementVNode("span", _hoisted_1, _toDisplayString(__props.title) + " Apple", 1),
          _createElementVNode("span", _hoisted_2, _toDisplayString(__props.title) + " Apple", 1)
        ], 64))
  ], 2))
}
}

})